import { render, staticRenderFns } from "./EmailStepDetail.vue?vue&type=template&id=248453d2&scoped=true"
import script from "./EmailStepDetail.vue?vue&type=script&lang=js"
export * from "./EmailStepDetail.vue?vue&type=script&lang=js"
import style0 from "./EmailStepDetail.vue?vue&type=style&index=0&id=248453d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248453d2",
  null
  
)

export default component.exports